// MainLayout.jsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const MainLayout = () => (
  <>
    <Header />
    <main>
      {/*main content goes here */}
      <Outlet />
    </main>
    <Footer />
  </>
);

export default MainLayout;
